import { EventTypes } from 'redux-segment';

import { createDepositCashupVersion } from 'actions/payment/beCreateDeposit.action';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { fromAnyToUglyJson } from 'utils/converters/json.util';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

const L = logger('cashupActions');

export const TRANSACTION_LOG_CSV_REQUEST = 'TRANSACTION_LOG_CSV_REQUEST';
export const TRANSACTION_LOG_CSV_SUCCESS = 'TRANSACTION_LOG_CSV_SUCCESS';
export const TRANSACTION_LOG_CSV_FAILURE = 'TRANSACTION_LOG_CSV_FAILURE';
export const HIDE_CASHUP_ERROR = 'HIDE_CASHUP_ERROR';
export const INIT_VOID_TRANSACTION_REQUEST = 'INIT_VOID_TRANSACTION_REQUEST';
export const INIT_VOID_TRANSACTION_SUCCESS = 'INIT_VOID_TRANSACTION_SUCCESS';
export const INIT_VOID_TRANSACTION_FAILURE = 'INIT_VOID_TRANSACTION_FAILURE';
export const INIT_VOID_TRANSACTION_DONE = 'INIT_VOID_TRANSACTION_DONE';
export const VOID_TRANSACTION_DETAILS_REQUEST = 'VOID_TRANSACTION_DETAILS_REQUEST';
export const VOID_TRANSACTION_DETAILS_SUCCESS = 'VOID_TRANSACTION_DETAILS_SUCCESS';
export const VOID_TRANSACTION_DETAILS_FAILURE = 'VOID_TRANSACTION_DETAILS_FAILURE';
export const VOID_TRANSACTION_DETAILS_DONE = 'VOID_TRANSACTION_DETAILS_DONE';
export const CREATE_DEPOSIT_BACK_END_REQUEST = 'CREATE_DEPOSIT_BACK_END_REQUEST';
export const CREATE_DEPOSIT_BACK_END_SUCCESS = 'CREATE_DEPOSIT_BACK_END_SUCCESS';
export const CREATE_DEPOSIT_BACK_END_FAILURE = 'CREATE_DEPOSIT_BACK_END_FAILURE';
export const FETCH_CASHUP_DEPOSITS_REQUEST = 'FETCH_CASHUP_DEPOSITS_REQUEST';
export const FETCH_CASHUP_DEPOSITS_SUCCESS = 'FETCH_CASHUP_DEPOSITS_SUCCESS';
export const FETCH_CASHUP_DEPOSITS_FAILURE = 'FETCH_CASHUP_DEPOSITS_FAILURE';
export const RESET_SAVED = 'RESET_SAVED';
export const GENERATE_VOUCHER_REQUEST = 'GENERATE_VOUCHER_REQUEST';
export const GENERATE_VOUCHER_SUCCESS = 'GENERATE_VOUCHER_SUCCESS';
export const GENERATE_VOUCHER_FAILURE = 'GENERATE_VOUCHER_FAILURE';
export const CREATE_VOUCHER_REQUEST = 'CREATE_VOUCHER_REQUEST';
export const CREATE_VOUCHER_SUCCESS = 'CREATE_VOUCHER_SUCCESS';
export const CREATE_VOUCHER_FAILURE = 'CREATE_VOUCHER_FAILURE';
export const UPDATE_VOUCHER_REQUEST = 'UPDATE_VOUCHER_REQUEST';
export const UPDATE_VOUCHER_SUCCESS = 'UPDATE_VOUCHER_SUCCESS';
export const UPDATE_VOUCHER_FAILURE = 'UPDATE_VOUCHER_FAILURE';
export const DELETE_VOUCHER_REQUEST = 'DELETE_VOUCHER_REQUEST';
export const DELETE_VOUCHER_SUCCESS = 'DELETE_VOUCHER_SUCCESS';
export const DELETE_VOUCHER_FAILURE = 'DELETE_VOUCHER_FAILURE';
export const GET_ALL_VOUCHER_REQUEST = 'GET_ALL_VOUCHER_REQUEST';
export const GET_ALL_VOUCHER_SUCCESS = 'GET_ALL_VOUCHER_SUCCESS';
export const GET_ALL_VOUCHER_FAILURE = 'GET_ALL_VOUCHER_FAILURE';
export const GET_CASHUP_VOUCHER_REQUEST = 'GET_CASHUP_VOUCHER_REQUEST';
export const GET_CASHUP_VOUCHER_SUCCESS = 'GET_CASHUP_VOUCHER_SUCCESS';
export const GET_CASHUP_VOUCHER_FAILURE = 'GET_CASHUP_VOUCHER_FAILURE';
export const CLEAR_CREATED_VOUCHER = 'CLEAR_CREATED_VOUCHER';
export const CHECK_VOUCHER_REQUEST = 'CHECK_VOUCHER_REQUEST';
export const CHECK_VOUCHER_SUCCESS = 'CHECK_VOUCHER_SUCCESS';
export const CHECK_VOUCHER_FAILURE = 'CHECK_VOUCHER_FAILURE';

export const GET_PRICE_REQUEST = 'GET_PRICE_REQUEST';
export const GET_PRICE_SUCCESS = 'GET_PRICE_SUCCESS';
export const GET_PRICE_FAILURE = 'GET_PRICE_FAILURE';

export const GET_TRANSACTIONS_STYLIST_REQUEST = 'GET_TRANSACTIONS_STYLIST_REQUEST';
export const GET_TRANSACTIONS_BY_STYLIST_SUCCESS = 'GET_TRANSACTIONS_BY_STYLIST_SUCCESS';
export const GET_TRANSACTIONS_BY_STYLIST_FAILURE = 'GET_TRANSACTIONS_BY_STYLIST_FAILURE';

export const getServicePriceList = (salonId) => ({
  ATAG: 'getServicePriceList',
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `services/v1/role/salon/${salonId}/`,
    authenticated: true,
    types: [GET_PRICE_REQUEST, GET_PRICE_SUCCESS, GET_PRICE_FAILURE],
  },
});

export const fetchDepositData = (salonID, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `cashup/${salonID}/deposits?start=${start}&end=${end}`,
      authenticated: true,
      types: [FETCH_CASHUP_DEPOSITS_REQUEST, FETCH_CASHUP_DEPOSITS_SUCCESS, FETCH_CASHUP_DEPOSITS_FAILURE],
    },
  };
};

// DEPRECATED: unused, there is a duplicate wit hthe same name transactionLogCSV in reports/actions that is used
export const transactionLogCSV = (salonId, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);

  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoin: `cashup/${salonId}/transactionlog?start=${start}&end=${end}`,
      authenticated: true,
      types: [TRANSACTION_LOG_CSV_REQUEST, TRANSACTION_LOG_CSV_SUCCESS, TRANSACTION_LOG_CSV_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: [startDate, endDate],
    },
  };
};

export const hideError = () => ({
  type: HIDE_CASHUP_ERROR,
  meta: { analytics: EventTypes.track },
});

const feStartVoidingTransactionFail = (options) => ({
  ATAG: feStartVoidingTransactionFail.name,
  type: INIT_VOID_TRANSACTION_FAILURE,
  errorMessage: fromAnyToTrimmed(options?.errorMessage) || 'No ID',
});

const startVoidingTransaction = (salonId, transactionData) => {
  const transactionId = transactionData?.id;
  const deposits = asArray(transactionData?.deposits?.clientDeposits || transactionData?.deposits);

  for (const deposit of deposits) {
    createDepositCashupVersion(
      {
        clientId: deposit.clientId,
        amount: Math.abs(deposit.amount),
        depositType: 'deposited',
        id: null,
        notes: 're-deposited via void transaction',
        created_for_appointmentId: null,
      },
      salonId,
    );
  }

  if (!transactionId) return feStartVoidingTransactionFail();

  return {
    ATAG: startVoidingTransaction.name,
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/${salonId}/void/${transactionId}`,
      authenticated: true,
      types: [
        INIT_VOID_TRANSACTION_REQUEST,
        INIT_VOID_TRANSACTION_SUCCESS,
        INIT_VOID_TRANSACTION_FAILURE,
        INIT_VOID_TRANSACTION_DONE,
      ],
      config: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: fromAnyToUglyJson({ ...(transactionData ?? void 1), void_reason: '' }),
      },
    },
  };
};

const getVoidedTransactionDetails = (salonId, oldTxId, newTxId) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `checkout/retrieve/${salonId}/transaction/${oldTxId}`,
    authenticated: true,
    types: [
      VOID_TRANSACTION_DETAILS_REQUEST,
      VOID_TRANSACTION_DETAILS_SUCCESS,
      VOID_TRANSACTION_DETAILS_FAILURE,
      VOID_TRANSACTION_DETAILS_DONE,
    ],
    params: { NewTransactionId: newTxId },
  },
});

export const voidAndGetDetails = (salonId, data) => (dispatch) => {
  const promiseInit = dispatch(startVoidingTransaction(salonId, data));

  L.unignore('voidAndGetDetails()', 'startVoidingTransaction:', promiseInit);

  promiseInit.then(({ response, type }) => {
    if (type !== INIT_VOID_TRANSACTION_SUCCESS) {
      return { type: INIT_VOID_TRANSACTION_FAILURE };
    }

    const oldTxId = response.created_from;
    const newTxId = response.id;

    const promiseDone = dispatch(getVoidedTransactionDetails(salonId, oldTxId, newTxId));
    L.unignore('voidAndGetDetails()', 'getVoidedTransactionDetails:', promiseDone);

    return promiseDone;
  });
};

export const resetSaved = () => ({ type: RESET_SAVED });

export const generateVoucherNumber = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `voucher/${salonId}/generate/`,
    authenticated: true,
    types: [GENERATE_VOUCHER_REQUEST, GENERATE_VOUCHER_SUCCESS, GENERATE_VOUCHER_FAILURE],
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export function createVoucher(salonId, voucherObj) {
  const endpoint = `voucher/${salonId}/create/`;
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [CREATE_VOUCHER_REQUEST, CREATE_VOUCHER_SUCCESS, CREATE_VOUCHER_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(voucherObj),
      },
    },
  };
}

export const checkVoucher = (salonId, voucherNumber, index) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `voucher/${salonId}/search/?number=${voucherNumber}`,
    authenticated: true,
    types: [CHECK_VOUCHER_REQUEST, CHECK_VOUCHER_SUCCESS, CHECK_VOUCHER_FAILURE],
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
    params: { index },
  },
});

// TODO: seems unused, remove it
export function updateVoucher(salonId, voucherId, expireObj) {
  /* expireObj
  {expires_at: '2021-02-20'}
  */
  const endpoint = `voucher/${salonId}/update/${voucherId}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [UPDATE_VOUCHER_REQUEST, UPDATE_VOUCHER_SUCCESS, UPDATE_VOUCHER_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(expireObj),
      },
    },
  };
}

export function deleteVoucher(id, salonId) {
  const endpoint = `voucher/${salonId}/delete/${id}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [DELETE_VOUCHER_REQUEST, DELETE_VOUCHER_SUCCESS, DELETE_VOUCHER_FAILURE],
      config: {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: {
        id,
      },
    },
  };
}

export function getAllVoucher(salonId) {
  const endpoint = `voucher/${salonId}/list/`;
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [GET_ALL_VOUCHER_REQUEST, GET_ALL_VOUCHER_SUCCESS, GET_ALL_VOUCHER_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

// FIXME: remove if unused
export const getCashupVoucher = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `cashup/${salonId}/voucher/`,
    authenticated: true,
    types: [GET_CASHUP_VOUCHER_REQUEST, GET_CASHUP_VOUCHER_SUCCESS, GET_CASHUP_VOUCHER_FAILURE],
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const clearCreatedVoucher = () => ({ type: CLEAR_CREATED_VOUCHER });

export const getTransactionsByStylist = (salonID, startDate, endDate, timeZone, stylistIds) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  const config = { method: 'GET', headers: { 'Content-Type': 'application/json' } };
  let idParam = '';

  for (let i = 0; i < stylistIds.length; i += 1) {
    idParam += `&stylist_id=${stylistIds[i]}`;
  }

  return {
    ATAG: getTransactionsByStylist.name,
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot, // eslint-disable-next-line max-len
      endpoint: `checkout/${salonID}/transactions/bystylist/export/?start=${start}&end=${end}&time_zone=${timeZone}${idParam}`,
      authenticated: true,
      types: [
        GET_TRANSACTIONS_STYLIST_REQUEST,
        GET_TRANSACTIONS_BY_STYLIST_SUCCESS,
        GET_TRANSACTIONS_BY_STYLIST_FAILURE,
      ],
      config,
      params: { start, end },
    },
  };
};
